<template>
  <div>
    <NavbarTwo />
    <div class="static-hero">
      <div class="container mw-1356">
        <span class="top-title">FAQ</span>
        <h1>{{ c.heading || 'Frequently Asked Questions' }}</h1>
        <p>{{ c.subheading || 'Everything you need to know about our service' }}</p>
      </div>
    </div>
    <div class="static-body bg-gondola">
      <div class="container mw-1356" style="max-width:860px">
        <div v-if="!items.length" class="text-center text-silver py-5">No FAQs yet.</div>
        <div v-else class="faq-list">
          <div
            v-for="(item, i) in items"
            :key="i"
            class="faq-item"
            :class="{ open: openIndex === i }"
          >
            <button class="faq-q" @click="openIndex = openIndex === i ? -1 : i">
              <span>{{ item.question }}</span>
              <i :class="openIndex === i ? 'ti ti-minus' : 'ti ti-plus'"></i>
            </button>
            <div class="faq-a" v-show="openIndex === i">{{ item.answer }}</div>
          </div>
        </div>
      </div>
    </div>
    <MainFooter />
    <CopyRight />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { useSeo } from "@/composables/useSeo";
import NavbarTwo from "@/components/Layouts/NavbarTwo.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "FaqPage",
  components: { NavbarTwo, MainFooter, CopyRight },
  setup() {
    useSeo({
      title: "Frequently Asked Questions",
      description: "Got questions about goplayTv IPTV? Find answers about setup, compatibility, World Cup 2026 coverage, supported devices, and subscription plans.",
      url: "/faq",
      keywords: "IPTV FAQ, how to watch World Cup 2026, IPTV setup, IPTV compatible devices, goplayTv help",
    });
    const { content } = useContent("faq", { heading: "", subheading: "", items: [] });
    const c = computed(() => content.value);
    const items = computed(() => Array.isArray(c.value.items) ? c.value.items : []);
    const openIndex = ref(-1);
    return { c, items, openIndex };
  },
});
</script>

<style scoped>
.static-hero {
  background: linear-gradient(135deg, #0a0102 0%, #1a0508 100%);
  padding: 100px 0 60px;
  border-bottom: 1px solid #2b1e1f;
  text-align: center;
}
.static-hero .top-title { display: inline-block; color: #c90e0e; font-size: 0.8rem; font-weight: 700; letter-spacing: 3px; text-transform: uppercase; margin-bottom: 1rem; }
.static-hero h1 { color: #fff; font-size: clamp(1.8rem, 4vw, 2.6rem); font-weight: 800; margin-bottom: 0.75rem; }
.static-hero p { color: #a0a0a0; }
.static-body { padding: 60px 0 80px; }
.faq-list { display: flex; flex-direction: column; gap: 0.75rem; }
.faq-item { background: #1a0f10; border: 1px solid #2b1e1f; border-radius: 10px; overflow: hidden; transition: border-color 0.2s; }
.faq-item.open { border-color: #c90e0e; }
.faq-q { display: flex; justify-content: space-between; align-items: center; gap: 1rem; width: 100%; background: transparent; border: none; color: #fff; font-weight: 600; font-size: 0.95rem; font-family: inherit; padding: 1.1rem 1.25rem; cursor: pointer; text-align: left; }
.faq-q i { flex-shrink: 0; color: #c90e0e; font-size: 1rem; }
.faq-a { color: #a0a0a0; font-size: 0.9rem; line-height: 1.7; padding: 0 1.25rem 1.1rem; }
</style>
